import moment from "moment";

export const textToDate = (value: string): moment.Moment | null => {
  switch (value) {
    case "asap":
    case "nu":
    case "now":
      return moment.utc();
    case "imorgon":
      return moment.utc().add(1, "day");
    default:
      // eslint-disable-next-line no-case-declarations
      const numberPattern = /^\d+/i;
      // eslint-disable-next-line no-case-declarations
      const match = value.match(numberPattern);

      if (match && match.length === 1) {
        const rest = value.substring(match[0].length).trim();
        const time = parseInt(match[0]);
        switch (rest) {
          case "year":
          case "years":
          case "y":
          case "month":
          case "months":
          case "M":
          case "week":
          case "weeks":
          case "w":
          case "day":
          case "days":
          case "d":
          case "hour":
          case "hours":
          case "h":
          case "minute":
          case "minutes":
          case "m":
          case "second":
          case "seconds":
          case "s":
          case "millisecond":
          case "milliseconds":
          case "ms":
            return moment.utc().add(time, rest);

          default:
            return null;
        }
      } else {
        return null;
      }
  }
};
